module.exports = __webpack_public_path__ + "static/media/code-brackets.d43eb968.svg";